import { TopToolbar, useTranslate } from 'react-admin';
import ExportResource from '@/components/global/buttons/ExportResource.jsx';
import CustomToolbarActionsPopover from '@/components/global/buttons/CustomToolbarActionsPopover';
import ColumnsIcon from '@/assets/icons/columns-icon.svg?react';
import { CustomSelectColumnsButton } from '@/components/global/buttons/CustomSelectColumnsButton.jsx';
import { SearchFilterInput } from '@/components/global/filters/SearchFilterInput';
import { PeriodFilterInput } from '@/components/global/filters/PeriodFilterInput.jsx';
import CustomFilterButton from '@/components/global/filters/CustomFilterButton';

export const TransactionListActions = () => {
    const translate = useTranslate();
    return (
        <TopToolbar>
            <SearchFilterInput />
            <PeriodFilterInput label={translate('resources.transaction.labels.period')} />
            <CustomFilterButton />
            <CustomSelectColumnsButton startIcon={<ColumnsIcon />} style={{ margin: '0px -4px' }} />
            <CustomToolbarActionsPopover>
                <ExportResource resource='transaction' format='csv' dataTransformer='transactions-to-csv-data' />
                <ExportResource
                    resource='transaction'
                    format='csv'
                    dataTransformer='transactions-including-invalid-to-csv-data'
                    label={translate('resources.transaction.labels.exportCsvInvalid')}
                />
            </CustomToolbarActionsPopover>
        </TopToolbar>
    );
};
